import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

// Docs page feedback widget — thumbs up saves immediately; thumbs down
// reveals a reason dropdown + optional comment before POSTing.
// Registered as "docs--feedback".
export default class extends Controller {
  static targets = ["prompt", "form", "thanks"]
  static values = { slug: String, endpoint: String }

  connect() {
    if (this._alreadySubmitted()) {
      this._showThanks()
    }
  }

  async thumbsUp() {
    await this._submit({ helpful: true })
    this._markSubmitted()
    this._showThanks()
  }

  thumbsDown() {
    this.promptTarget.classList.add("hidden")
    if (this.hasFormTarget) {
      this.formTarget.classList.remove("hidden")
      const textarea = this.formTarget.querySelector("textarea")
      if (textarea) textarea.focus()
    } else {
      // No form available — record the negative vote without detail.
      this._submit({ helpful: false }).finally(() => {
        this._markSubmitted()
        this._showThanks()
      })
    }
  }

  async submit(event) {
    event.preventDefault()
    const form = event.currentTarget
    const reason = form.querySelector("[name=reason]")?.value || ""
    const comment = form.querySelector("[name=comment]")?.value || ""
    await this._submit({ helpful: false, reason, comment })
    this._markSubmitted()
    this._showThanks()
  }

  // --- private ---

  async _submit(body) {
    if (!this.hasEndpointValue || !this.endpointValue) return
    try {
      await post(this.endpointValue, {
        body: { slug: this.slugValue, ...body },
        responseKind: "json",
      })
    } catch {
      // Feedback must never block the reader.
    }
  }

  _showThanks() {
    this.promptTarget.classList.add("hidden")
    if (this.hasFormTarget) this.formTarget.classList.add("hidden")
    this.thanksTarget.classList.remove("hidden")
  }

  _storageKey() {
    return `docs-feedback-${this.slugValue}`
  }

  _alreadySubmitted() {
    try {
      return !!localStorage.getItem(this._storageKey())
    } catch {
      return false
    }
  }

  _markSubmitted() {
    try {
      localStorage.setItem(this._storageKey(), Date.now().toString())
    } catch {
      // localStorage unavailable
    }
  }
}
